export default __webpack_public_path__ + "locales/ja-JP/Common.json?hash=449f2115531c171da8ae9aa42bc1c59c";